import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function Modal({ open, onClose, children, title, maxWidth = "var(--modal-max-width)", borderRadius = 0, mobileFullScreen = true }) {
  // Prevent background scroll when open
  useEffect(() => {
    if (!open) return;
    const { body } = document;
    const prev = body.style.overflow;
    body.style.overflow = "hidden";
    return () => { body.style.overflow = prev; };
  }, [open]);

  // Close on Esc
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      aria-modal="true"
      role="dialog"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "var(--background-overlay)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      <div
        className={mobileFullScreen ? "modal__sheet" : undefined}
        onClick={(e) => e.stopPropagation()}
        style={{
          // A fixed-px margin floor (not a percentage) so there's always a
          // guaranteed, visible gap to the screen edge on narrow phones.
          width: `min(${maxWidth}, calc(100% - 2rem))`,
          background: "var(--background-primary)",
          color: "var(--text-primary)",
          borderRadius,
          padding: 16,
          boxShadow: "var(--shadow-xl)",
          maxHeight: "92vh",
          overflow: "auto",
          border: `1px solid var(--border-color)`,
        }}
      >
        <div
          className="modal__titlebar"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 12,
            gap: 8,
          }}
        >
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, flex: 1, color: "var(--text-primary)" }}>
            {title || "Playback"}
          </h3>
          <button
            className="btn-icon"
            onClick={onClose}
            aria-label="Close"
            title="Close"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "transparent",
              color: "var(--text-secondary)",
              border: 0,
              cursor: "pointer",
              padding: 4,
            }}
          >
            <FiX size={20} />
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
